'use client'

import { Stack, Text, UnstyledButton } from '@mantine/core'
import { FC, MouseEvent } from 'react'

interface ActionReusableDesignProps {
  title: string
  items: { label: string; url?: string }[]
}

export const ActionReusableDesign: FC<ActionReusableDesignProps> = ({
  title,
  items,
}) => {
  const handleMouseEnter = (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => {
    e.currentTarget.style.opacity = '1'
  }

  const handleMouseLeave = (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => {
    e.currentTarget.style.opacity = '0.85'
  }

  return (
    <Stack
      style={{
        minWidth: 155,
        gap: '18px',
      }}
    >
      <Text
        style={{
          color: '#FFFFFFB3',
          fontSize: '14px',
          fontWeight: 500,
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        {title}
      </Text>

      <Stack style={{ gap: '12px' }}>
        {items.map((item, index) => {
          const isLink = !!item.url
          return (
            <UnstyledButton
              key={index}
              component={isLink ? 'a' : 'button'}
              href={isLink ? item.url : undefined}
              style={{
                textAlign: 'left',
                color: '#FFFFFF',
                fontSize: '13px',
                fontWeight: 500,
                fontFamily: 'Poppins, sans-serif',
                lineHeight: '160%',
                cursor: isLink ? 'pointer' : 'default',
                transition: 'opacity 0.2s, color 0.2s',
              }}
              onMouseEnter={isLink ? handleMouseEnter : undefined}
              onMouseLeave={isLink ? handleMouseLeave : undefined}
              aria-label={item.label}
            >
              {item.label}
            </UnstyledButton>
          )
        })}
      </Stack>
    </Stack>
  )
}
